import OfficesRelatedJobs from './OfficesRelatedJobs';

export { type OfficesRelatedJobsProps } from './OfficesRelatedJobs';
export default OfficesRelatedJobs;
